import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PrecioNetoFormGroup = () => {
  return (
    <Form.Group>
      <Form.Label text='PRECIO NETO' htmlFor='input-precioNeto' xs={12} />
      <Col xs={12}>
        <Field name='precioNeto'>{({ field }) => <Form.InputText {...field} disabled id='input-precioNeto' />}</Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(PrecioNetoFormGroup)
